import React from 'react';
import { SimpleLinkContainer } from '@components/SimpleLink/SimpleLink.styled';
import { useThemeGetter } from '@hooks';
import { SimpleLinkProps } from '@components/SimpleLink/SimpleLink.types';
import { SiteIcon } from '@assets/icons';

export const SimpleLink = ({ link, icon = <SiteIcon /> }: SimpleLinkProps) => {
  const {
    theme: { Secondary },
  } = useThemeGetter();

  return (
    <SimpleLinkContainer href={link} color={Secondary} target="_tab">
      {icon}
    </SimpleLinkContainer>
  );
};
